import { UploaderError } from "./UploaderError";
export class UnsupportedFileSourceError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UnsupportedFileSourceError";
    }
}
export class UnsupportedFileTypeError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UnsupportedFileTypeError";
    }
}
export class FileSystemNotFoundError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileSystemNotFoundError";
    }
}
export class FileSystemPermissionDeniedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileSystemPermissionDeniedError";
    }
}
export class FileSystemUnknownError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileSystemUnknownError";
    }
}
export class FileReaderNotFoundError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileReaderNotFoundError";
    }
}
export class FileReaderSecurityError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileReaderSecurityError";
    }
}
export class FileReaderNotReadableError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileReaderNotReadableError";
    }
}
export class FileReaderUnknownError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileReaderNotReadableError";
    }
}
export class FileReaderAbortError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileReaderAbortError";
    }
}
export class FileSystemAbortError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "FileSystemAbortError";
    }
}
export class EmptyFileListError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "EmptyFileListError";
    }
}
export class UnvalidTokenError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UnvalidTokenError";
    }
}
export class TransferAlreadyStartingError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyStartingError";
    }
}
export class TransferAlreadyStartedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyStartedError";
    }
}
export class TransferAlreadyCancelingError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyCancelingError";
    }
}
export class TransferAlreadyCanceledError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyCanceledError";
    }
}
export class TransferAlreadyFinishingError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyFinishingError";
    }
}
export class TransferAlreadyFinishedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyFinishedError";
    }
}
export class TransferAlreadyPausedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyPausedError";
    }
}
export class TransferAlreadyQueuedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferAlreadyQueuedError";
    }
}
export class TransferIsInErrorError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferIsInErrorError";
    }
}
export class NetworkError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "NetworkError";
    }
}
export class UnauthorizedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class InvalidParameterError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class InvalidDeliveryError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "InvalidDeliveryError";
    }
}
export class EmailNotAllowedError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "EmailNotAllowedError";
    }
}
export class InvalidAvailabilityDurationError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "InvalidAvailabilityDurationError";
    }
}
export class InvalidSubscriptionError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionError";
    }
}
export class MissingReceiversError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "MissingReceiversError";
    }
}
export class MissingSenderError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "MissingSenderError";
    }
}
export class PasswordRequiredError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRequiredError";
    }
}
export class UsageExceededError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UsageExceededError";
    }
}
export class OwnerUsageExceededError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "OwnerUsageExceededError";
    }
}
export class CustomUrlAlreadyInUseError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "CustomUrlAlreadyInUseError";
    }
}
export class TransferNotFoundError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "TransferNotFoundError";
    }
}
export class UnknownError extends UploaderError {
    constructor() {
        super(...arguments);
        this.name = "UnknownError";
    }
}
